export default __webpack_public_path__ + "static/media/KZ.781fbde8.svg";